var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.config.visible
    ? _c(
        "AppDialog",
        {
          attrs: {
            title: _vm.title,
            width: "600px",
            height: "165px",
            top: "10vh",
          },
          model: {
            value: _vm.config.visible,
            callback: function ($$v) {
              _vm.$set(_vm.config, "visible", $$v)
            },
            expression: "config.visible",
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "choose_resource",
            },
            [
              _vm.isPhoneVerification
                ? _c(
                    "el-form",
                    {
                      ref: "phoneForm",
                      attrs: {
                        model: _vm.phoneForm,
                        rules: _vm.rules,
                        "label-width": "100px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "手机号码", prop: "phoneNumber" } },
                        [_vm._v(" " + _vm._s(_vm.phoneForm.phoneNumber) + " ")]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "验证码", prop: "code" } },
                        [
                          _c(
                            "el-row",
                            {
                              staticStyle: { height: "40px" },
                              attrs: { gutter: 10 },
                            },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 11 } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      clearable: "",
                                      maxlength: "6",
                                      "show-word-limit": "",
                                    },
                                    model: {
                                      value: _vm.phoneForm.code,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.phoneForm,
                                          "code",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "phoneForm.code",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                {
                                  staticStyle: { height: "40px" },
                                  attrs: { span: 6 },
                                },
                                [
                                  _vm.sendDisabled
                                    ? _c(
                                        "span",
                                        { staticClass: "login-send-code" },
                                        [_vm._v(_vm._s(_vm.time + "秒后获取"))]
                                      )
                                    : _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "loading",
                                              rawName: "v-loading",
                                              value: _vm.btnLoading,
                                              expression: "btnLoading",
                                            },
                                          ],
                                          staticClass: "login-send-code",
                                          staticStyle: { width: "100%" },
                                          on: { click: _vm._sendCode },
                                        },
                                        [_vm._v(_vm._s(_vm.btnText))]
                                      ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _c(
                    "el-form",
                    {
                      ref: "ruleForm",
                      attrs: {
                        model: _vm.form,
                        rules: _vm.rules,
                        "label-width": "100px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "新密码", prop: "newPassword" } },
                        [
                          _c(
                            "div",
                            [
                              _c("el-input", {
                                staticClass: "w-300",
                                attrs: {
                                  "show-password": "",
                                  "auto-complete": "new-password",
                                },
                                on: {
                                  input: (e) =>
                                    _vm.nickNameInput(e, "newPassword"),
                                },
                                model: {
                                  value: _vm.form.newPassword,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "newPassword",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "form.newPassword",
                                },
                              }),
                              _c("div", [
                                _vm._v(
                                  "（密码必须包含英文和数字，长度不能少于8位。）"
                                ),
                              ]),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "确认新密码",
                            prop: "confirmPassword",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "w-300",
                            attrs: { "show-password": "" },
                            on: {
                              input: (e) =>
                                _vm.nickNameInput(e, "confirmPassword"),
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.successFn.apply(null, arguments)
                              },
                            },
                            model: {
                              value: _vm.form.confirmPassword,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "confirmPassword",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "form.confirmPassword",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "password-modal-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _vm.isPhoneVerification
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.verificationFn },
                    },
                    [_vm._v("下一步")]
                  )
                : _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.successFn()
                        },
                      },
                    },
                    [_vm._v("确定")]
                  ),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }